<img class="ugm-logo" src="assets/logos/logo_ugm.svg" width="45" alt="umgrauemeio" />

<div class="content">
  <img class="pantera-logo" src="assets/logos/pantera_head_negative.svg" alt="Pantera" />
  <h2 id="mobile-app-title">{{ 'MOBILE_APP.TITLE' | translate }}</h2>
  <p>{{ 'MOBILE_APP.MESSAGE' | translate }}</p>
</div>

<div class="actions">
  <a class="store-btn" [href]="data.storeUrl" target="_self">
    {{ 'MOBILE_APP.OPEN_STORE' | translate: { store: data.storeName } }}
  </a>
  <button class="browser-btn" type="button" mat-dialog-close>
    {{ 'MOBILE_APP.CONTINUE_BROWSER' | translate }}
  </button>
</div>
